/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useQuery} from "@apollo/react-hooks";
import {SizeMe} from "react-sizeme";
import MaterialTable from "material-table";
import tableIcons from "../../constants/tableIcons";
import Moment from "react-moment";
import CalendarStrings from "../../constants/calendarStrings";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import {GET_POSITIONS_OF_CONTACT} from "../../database/queries/contactQueries";
import {GET_CONTACT_ACCOUNT_POSITIONS} from "../../database/queries/contactAccountPositionQueries";

// TODO high - personExperienceList - fix search box

const inIFrame = (window.parent.window !== window);

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    iFrameTableContainer: {
        width: '100%',
        overflow: 'auto',
    },
    tableContainer: {
        width: '100%',
        overflow: 'auto',
    },
    headerText: {
        fontSize: '95%',
        fontWeight: 'bold',
    }
}));

const columns = [
    {
        title: 'Account',
        width: '25%',
        render: r => {
            if (r.account) {
                if (inIFrame || !r.account.accountLinkedinId) {
                    return <span>{r.account.accountName}</span>
                } else {
                    return <a href={'https://linkedin.com/company/' + r.account.accountLinkedinId}
                              target={"_blank"} rel="noopener noreferrer">{r.account.accountName}</a>
                }
            } else {
                return ""
            }
        },
        headerStyle: {padding: 6},
        cellStyle: {padding: 6}
    },
    {
        title: 'Title',
        width: '45%',
        field: 'title',
        headerStyle: {padding: 6},
        cellStyle: {padding: 6}
    },
    {
        title: 'Start',
        width: '20%',
        render: r => <Moment calendar={CalendarStrings}>{r.startDate}</Moment>,
        headerStyle: {padding: 6, textAlign: 'right', justifyContent: 'right'},
        cellStyle: {padding: 6, textAlign: 'right', justifyContent: 'right'}
    },
    {
        title: 'End',
        width: '20%',
        render: r => {
            if (r.current) {
                return (<span>Present</span>)
            } else {
                return (<Moment calendar={CalendarStrings}>{r.endDate}</Moment>);
            }
        },
        headerStyle: {padding: 6, textAlign: 'right', justifyContent: 'right'},
        cellStyle: {padding: 6, textAlign: 'right', justifyContent: 'right'}
    },
];

const ContactAccountPositionsExperienceList = props => {
    const classes = useStyles();
    const [searchStr] = useState();
    const [globalLayoutState] = useLayoutStore();

    const {
        loading: getContactAccountPositionsLoading,
        error: getContactAccountPositionsError,
        data: getContactAccountPositionsData,
        refetch: getContactAccountPositionsRefetch
    } = useQuery(GET_CONTACT_ACCOUNT_POSITIONS, {
        skip: !props.editId,
        variables: {
            contactId: props.editId,
            searchStr: searchStr,
            // limit: 10,
            // offset: 0,
            orderList: ['endDate DESC', 'startDate DESC']
        },
    });

    useEffect(() => {
        if (getContactAccountPositionsError) notify('getContactAccountPositionsError', 'error', getContactAccountPositionsError.message);
    }, [getContactAccountPositionsError]);

    useEffect(() => {
        console.log('getContactAccountPositionsData', getContactAccountPositionsData);
    }, [getContactAccountPositionsData]);

    useEffect(() => {
        getContactAccountPositionsRefetch();
    }, [searchStr]);

    useEffect(() => {
    }, [globalLayoutState.tabBarHeight]);

    if (getContactAccountPositionsLoading) {
        return <p>Loading ...</p>;
    }
    if (getContactAccountPositionsError) {
        return `Error! ${getContactAccountPositionsError.message}`;
    }

    return (
        <div className={classes.root}>
            {getContactAccountPositionsData && getContactAccountPositionsData.contactAccountPositions && (
                <SizeMe>
                    {({size}) => {
                        let height = size.height;
                        if (!height) height = window.innerHeight;
                        const tableOptions = {
                            maxBodyHeight: height - (globalLayoutState.tabBarHeight + 160),
                            padding: 'dense',
                            addRowPosition: 'first',
                            header: true,
                            paging: false,
                            showTitle: true,
                            search: true,
                            actionsColumnIndex: -1
                        };

                        return (
                            <MaterialTable
                                icons={tableIcons}
                                title={`Positions`}
                                columns={columns}
                                data={getContactAccountPositionsData.contactAccountPositions}
                                options={tableOptions}
                            />
                        );
                    }}
                </SizeMe>
            )}
        </div>
    )
};

export default ContactAccountPositionsExperienceList
